//eslint-disable-next-line no-restricted-imports
import { useTheme } from '@material-ui/core';

/**
 * Detects whether the current page uses a mixed theme (v1 + v2 coexistence).
 *
 * When the page renders the legacy v1 theme and the new v2 theme at the same time,
 * it will have a `colorShades` property in theme object. When `isMixedPage` is `true`
 * dark mode should be disabled and PortraitOrientationLock will be suppressed because of performance cost
 */
const useMixedThemePageDetector = (): { isMixedPage: boolean } => {
  const v1Theme = useTheme();
  return { isMixedPage: !!v1Theme.colorShades };
};

export default useMixedThemePageDetector;

